import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';

export interface PortfolioReportDTO {
  id: string;
  name: string;
  description: string | null;
  category: string | null;
}

const fetchPortfolioReports = async (clientId: number): Promise<PortfolioReportDTO[]> => {
  return authFetch(
    urlWithParams('/Consumer/Reports/GetAvailableReports', {
      clientId,
    }),
  );
};

export const PORTFOLIO_REPORTS_QUERY_KEY = 'portfolioReports';

export const usePortfolioReportsQuery = () => {
  const clientId = useClientId();

  return useQuery([PORTFOLIO_REPORTS_QUERY_KEY, clientId], () => fetchPortfolioReports(clientId));
};
